
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M22.3 13.77L20.44 11.9C20.05 11.51 19.42 11.51 19.03 11.9C18.64 12.29 18.64 12.92 19.03 13.31L20.54 14.83L14.88 20.49L3.56001 9.17L9.22001 3.51L10.62 4.91C11.01 5.3 11.64 5.3 12.03 4.91C12.42 4.52 12.42 3.89 12.03 3.5L10.28 1.75C9.69001 1.16 8.74001 1.16 8.16001 1.75L1.80001 8.11C1.21001 8.7 1.21001 9.65 1.80001 10.23L13.82 22.25C14.41 22.84 15.36 22.84 15.94 22.25L22.3 15.89C22.89 15.3 22.89 14.35 22.3 13.77ZM15.05 10H20.05C20.6 10 21.05 9.55 21.05 9V5C21.05 4.45 20.6 4 20.05 4V3.5C20.05 2.12 18.93 1 17.55 1C16.17 1 15.05 2.12 15.05 3.5V4C14.5 4 14.05 4.45 14.05 5V9C14.05 9.55 14.5 10 15.05 10ZM15.85 3.5C15.85 2.56 16.61 1.8 17.55 1.8C18.49 1.8 19.25 2.56 19.25 3.5V4H15.85V3.5ZM8.85001 20.15L7.52001 21.48C4.43001 20.02 2.18001 17.11 1.63001 13.62C1.57001 13.21 1.19001 12.93 0.770013 13C0.360013 13.06 0.0800133 13.45 0.150013 13.86C0.750013 17.67 3.11001 20.87 6.39001 22.61C7.96001 23.44 9.94001 24.04 12.19 23.99C12.37 23.99 12.45 23.77 12.33 23.64L8.85001 20.15Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-screen-lock-rotation`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconScreenLockRotation

    ```js
    <b-new-b-icon-screen-lock-rotation />
    ```
</docs>


